import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { makeStyles } from "@material-ui/core/styles";
import { dataService } from '../../../Services/data.service';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import Button from '@material-ui/core/Button';

export default function ProductionStateDialog({ productionState, currentUserId, updateRows, ...props }) {

    const classes = useStyles();
    const { t } = useTranslation();

    const [cuttingTrash, setCuttingTrash] = useState(productionState.cuttingTrash);
    const [comment, setComment] = useState(productionState.comment);
    const [formErrors, setFormErrors] = useState({
        cuttingTrash: "",
        comment: "",
    });

    const updateProductionState = () => {
        let dateTime = new Date().toISOString();
        let productionStateOrderLog = {
            id: productionState.id,
            productionOrderLineId: productionState.productionOrderLineId,
            machineId: productionState.machineId,
            state: productionState.state,
            packer: productionState.packer,
            bookingPallet: productionState.bookingPallet,
            scrapUpper: productionState.scrapUpper,
            scrapLower: productionState.scrapLower,
            standStillType: productionState.standStillType,
            productId: productionState.productId,
            output: productionState.output,
            cuttingTrash: parseInt(cuttingTrash),
            comment: comment,
            isActive: productionState.isActive,
            insertedOn: productionState.insertedOn,
            insertedByUserId: productionState.insertedByUserId,
            updatedOn: dateTime,
            updatedByUserId: parseInt(currentUserId)
        }
        dataService.updateProductionStateOrderLog(productionStateOrderLog).then(() => {

        }).catch((error) => { console.log(error) });
    }

    const handleSaveChanges = () => {

        if (!isFormValid()) {
            return;
        } else {
            let tempProductionState = productionState;
            if (typeof cuttingTrash === "string") {
                if (cuttingTrash === "") {
                    tempProductionState.cuttingTrash = null;
                } else {
                    tempProductionState.cuttingTrash = parseInt(cuttingTrash);
                }
            }
            tempProductionState.comment = comment;

            updateProductionState();
            updateRows(tempProductionState);

            props.closeDialog();
        }
    }

    // form validation
    const isFormValid = () => {
        let isValid = true;

        if (isNaN(cuttingTrash)) {
            setFormErrors({ cuttingTrash: t("Gelieve een nummer in te vullen") });
            isValid = false;
        } else if (cuttingTrash < 0) {
            setFormErrors({ cuttingTrash: t("Snijafval kan geen negatief getal zijn") });
            isValid = false;
        } else {
            setFormErrors({ cuttingTrash: "" });
        }
        return isValid;
    }

    return (
        <Dialog
            className={classes.dialogContainer}
            open={props.dialogOpen}
            aria-labelledby="draggable-dialog-title"
            onClose={props.closeDialog}
            classes={{ paper: classes.dialogPaper }}
        >
            <DialogTitle className={classes.dialogTitle} id="draggable-dialog-title">
                {productionState.reference}
            </DialogTitle>
            <DialogContent className={classes.dialogContent}>
                <form className={classes.editForm}>
                    <div className={classes.editField}>
                        <label className={classes.label}>{t("Snijafval") + " (mm)"}</label>
                        <input className={classes.input} type="number" min={0} value={cuttingTrash} style={{ border: (formErrors.cuttingTrash !== null && formErrors.cuttingTrash !== "" && formErrors.cuttingTrash !== undefined) && "1px solid #D84949" }} onChange={(e) => setCuttingTrash(e.target.value)} />
                        <em className={classes.inputError}>{formErrors.cuttingTrash}</em>
                    </div>
                    <div className={classes.editField}>
                        <label className={classes.label}>{t("Opmerking")}</label>
                        <textarea className={classes.textarea} value={comment} onChange={(e) => setComment(e.target.value)} />
                    </div>
                </form>
            </DialogContent>
            <DialogActions className={classes.dialogActions}>
                <div className={classes.buttonContainer}>
                    <Button className={classes.buttonSecondary} variant='outlined' style={{ marginRight: "10px" }} onClick={props.closeDialog} >
                        {t("Annuleren")}
                    </Button>
                    <Button className={classes.buttonPrimary} variant='contained' onClick={() => handleSaveChanges()} >
                        {t("Opslaan")}
                    </Button>
                </div>
            </DialogActions>
        </Dialog>
    );
}


const useStyles = makeStyles(() => ({
    dialogContainer: {
        margin: "auto",
    },

    dialogPaper: {
        minWidth: '720px',
        minHeight: '384px',
        width: '720px !important',
        borderRadius: '6px',
    },

    dialogTitle: {
        fontSize: "24px",
        padding: "16px !important",
    },

    dialogContent: {
        padding: "8px 16px !important",
    },

    editForm: {
        display: "flex",
        flexDirection: "column",
        gap: "16px",
        margin: "0px",
    },

    editField: {
        display: "flex",
        flexDirection: "column",
        gap: "8px",
    },

    label: {
        fontSize: "16px",
    },

    inputError: {
        color: "#D84949",
        lineHeight: '0px',
        fontSize: '12px'
    },

    input: {
        fontSize: "16px",
        fontFamily: "Lato, sans-serif",

        height: "40px",
        width: "200px",
        padding: "0 12px",
        borderRadius: "5px",
        border: "1px solid #DEDEDE",
    },

    textarea: {
        fontSize: "16px",
        fontFamily: "Lato, sans-serif",

        height: "156px",
        width: "100%",
        padding: "10px 12px",
        borderRadius: "5px",
        border: "1px solid #DEDEDE",
    },

    dialogActions: {
        padding: "16px !important",
    },

    buttonContainer: {
        width: "100%",
        display: "flex",
        justifyContent: "space-between",
    },

    buttonPrimary: {
        color: "white !important",
        fontSize: "16px !important",
        fontWeight: "bold !important",
        fontFamily: "Lato, sans-serif !important",
        backgroundColor: "#4654FB !important",
        border: "1px solid #4654FB !important",
        minWidth: "fit-content !important",
        height: '40px !important',
        padding: '0px 20px !important',
        textTransform: 'capitalize !important',
        boxShadow: 'none !important',

        '&:hover': {
            backgroundColor: "white !important",
            color: "#4654FB !important",
            border: "1px solid #4654FB !important",
        },
    },

    buttonSecondary: {
        color: "#4654FB !important",
        fontSize: "16px !important",
        fontWeight: "bold !important",
        fontFamily: "Lato, sans-serif !important",
        backgroundColor: "white !important",
        border: "1px solid #4654FB !important",
        minWidth: "fit-content !important",
        height: '40px !important',
        padding: '0px 20px !important',
        textTransform: 'capitalize !important',

        '&:hover': {
            backgroundColor: "#4654FB !important",
            color: "white !important",
            border: "1px solid #4654FB !important",
        },
    },

}));
